import React, { useState, Fragment, useContext, useEffect } from "react";
import { Transition } from "@headlessui/react";
import { Link, useNavigate } from "react-router-dom";
import "./main.css";
import logo from "./media/goldlogo-crop.png";
import { BsPersonFill } from "react-icons/bs";
import { AuthContext } from "../Context/AuthContextProvider";
import $ from "jquery";
import { AButton } from "../Assets/Elements";
import { ThreeDots } from "react-loader-spinner";
import MainHeaderDropdownMenu from "./MainHeaderDropdownMenu";
import { GiHamburgerMenu } from "react-icons/gi";

function TopBar() {
  const { isAuth, logoutme, loginUser } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    $(window).on("scroll", function () {
      $(window).scrollTop()
        ? $(".Topbarmain").addClass("black")
        : $(".Topbarmain").removeClass("black");
    });
  }, []);

  let handleClick2 = async () => {
    setIsLoading(true);
    if (isAuth === true) {
      await logoutme({ email: loginUser.email_id });
      navigate("/Login");
    } else {
      navigate("/Login");
    }
    setIsLoading(false);
  };
  const [showHambuger, setShowHambuger] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <div className="flex flex-col p-10 py-0 max-w-8xl mx-auto space-y-4 Topbarmain pb-8 ">
        <div className="flex items-center  container">
          <Link to="/" className="md:max-w-[20%] md:pl-4" onClick={scrollToTop}>
            <img src={logo} alt="" className="topbar-logo w-full " />
          </Link>

          <div className="flex w-full justify-end relative left-[-10px] w-[175%]">
            <div className="flex items-center space-x-4">
              <div className="hidden lg:flex space-x-8 justify-around items-end space-y-2 text-[18px] pb-2 mr-4">
                <Link to="/Marketplace" className=" Nav-linkk ">
                  Domain Marketplace
                </Link>
                <Link to="/sell-your-dot-gold-domain" className=" Nav-linkk ">
                  Sell .Gold Domain
                </Link>
                {/* Deletable */}
                <Link to="/About" className=" Nav-linkk ">
                  About
                </Link>{" "}
                <Link to="/marketplace-help" className=" Nav-linkk ">
                  Contact
                </Link>
                {isAuth ? null : (
                  <Link to="/login" className=" Nav-linkk ">
                    Login
                  </Link>
                )}
              </div>
              {/* USER ACC  */}
            </div>
          </div>
          <ul className="navbar-nav !ml-0 hidden md:block">
            <li className=" dropdown">
              <div className="nav-link">
                {isAuth ? (
                  <MainHeaderDropdownMenu />
                ) : (
                  <div>
                    <Link to="/Signup">
                      <AButton>SIGNUP</AButton>
                    </Link>
                  </div>
                )}
              </div>
            </li>
          </ul>

          <div className="flex space-x-2 ">
            <div className="hidden md:hidden">
              <button
                className="custom-btn main-button login-btn1 topbar-para"
                onClick={() => navigate("/login")}
              >
                Login
              </button>
              <button
                type="button"
                className=" flex justify-center items-center p-2 xs:mt-2 lg:!mt-0 sm:px-2 sm:py-2 pl-0 sm:!pl-2 rounded-md bg-[#fbcb04] text-white hover:bg-[#ffe053] transition-all loginbtn "
                onClick={() => navigate("/login")}
              >
                <div className="hidden sm:block text-xl font-semibold loginbtn-hover:!text-black topbar-para">
                  Login
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 !xs:pl-0 !xs:pr-2 items-start loginbtn-hover:color-black text-white"
                  fill="white"
                  viewBox="0 0 24 24"
                  stroke="white"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </button>
            </div>
            <div className="md:hidden">
              <button
                onClick={() => navigate("/login")}
                className="auction-login-small-screen min-w-[30px] mt-[3px]"
              >
                <span className="flex align-items-center gap-[4px]">
                  <BsPersonFill fontSize={"22px"} />
                </span>
              </button>
            </div>

            <div className="flex items-center lg:hidden">
              <button
                type="button"
                onClick={() => setShowHambuger(true)}
                className="p-[4px]  rounded-md !bg-[#ede7d4] hover:bg-[#b99653]  min-w-[30px]"
              >
                <GiHamburgerMenu className="text-[#311e17] text-[22px] " />
              </button>
            </div>
          </div>
        </div>
        <Transition
          as={Fragment}
          show={showHambuger}
          enter="transition ease-in-out duration-800"
          enterFrom="transform opacity-0 translate-x-[999px]"
          enterTo="transform opacity-100 translate-x-0"
          leave="transition ease-in duration-800"
          leaveFrom="transform opacity-100 translate-x-0"
          leaveTo="transform opacity-0 translate-x-[999px]"
        >
          <div className="mobile-nav absolute  justify-start items-end z-30 flex flex-col bg-[#f2f4f5]">
            <button
              type="button"
              onClick={() => setShowHambuger(false)}
              className="flex space-x-1 items-center p-2 rounded-md hover:bg-[#b99653] hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8 ml-0"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <div className="flex flex-col w-full justify-center align-items-center text-[#fbcb04]">
              <Link
                to="/Marketplace"
                className="hover:underline  w-full text-center mobile-nav-item pt-4 pb-2"
                onClick={() => setShowHambuger(false)}
              >
                Domain Marketplace
              </Link>
              <Link
                to="/sell-your-dot-gold-domain"
                className="hover:underline  w-full text-center mobile-nav-item pt-4 pb-2"
                onClick={() => setShowHambuger(false)}
              >
                Sell .Gold Domain
              </Link>
              {/* <Link
                to="/AuctionAppraisals"
                className="hover:underline  w-full text-center mobile-nav-item  pt-4 pb-2"
                onClick={() => setShowHambuger(false)}
              >
                Domain Appraisals
              </Link> */}

              <Link
                to="/marketplace-help"
                className="hover:underline text-center mobile-nav-item  w-full pt-4 pb-2"
                onClick={() => setShowHambuger(false)}
              >
                Contact
              </Link>

              {isAuth ? (
                ""
              ) : (
                <Link
                  to="/login"
                  className="hover:underline  w-full text-center mobile-nav-item  pt-4 pb-2"
                >
                  Login
                </Link>
              )}

              {isAuth ? (
                <div className="mobile-profile">
                  <Link
                    to="/dashboard/profile"
                    className="hover:underline  w-full text-center mobile-nav-item  pt-4 pb-2"
                    onClick={() => setShowHambuger(false)}
                  >
                    <span className="drop-item-span">My Profile</span>
                  </Link>
                  <Link
                    to="/dashboard/EditAccountDetails"
                    className="hover:underline  w-full text-center mobile-nav-item  pt-4 pb-2"
                    onClick={() => setShowHambuger(false)}
                  >
                    <span className="drop-item-span">Edit Profile</span>
                  </Link>
                  <Link
                    to="/dashboard/Domains"
                    className="hover:underline  w-full text-center mobile-nav-item  pt-4 pb-2"
                    onClick={() => setShowHambuger(false)}
                  >
                    <span className="drop-item-span">My Domains</span>
                  </Link>

                  <Link
                    to="/dashboard/MySubmissions"
                    className="hover:underline  w-full text-center mobile-nav-item  pt-4 pb-2"
                    onClick={() => setShowHambuger(false)}
                  >
                    <span className="drop-item-span">My Submissions</span>
                  </Link>

                  <Link
                    to="/dashboard/AllTickets"
                    className="hover:underline  w-full text-center mobile-nav-item  pt-4 pb-2"
                    onClick={() => setShowHambuger(false)}
                  >
                    <span className="drop-item-span">Tickets</span>
                  </Link>

                  <button
                    onClick={handleClick2}
                    className="w-full text-center  gap-[10px] mobile-nav-item mt-[16px]  flex white-btn"
                  >
                    {isLoading ? (
                      <ThreeDots
                        color="#64432f"
                        height={25}
                        width={40}
                        timeout={1000000}
                      />
                    ) : (
                      "Logout"
                    )}
                  </button>
                </div>
              ) : (
                <Link
                  to="/Signup"
                  className="hover:underline text-center mobile-nav-item  w-full  pt-4 pb-2"
                >
                  SignUp
                </Link>
              )}
            </div>
          </div>
        </Transition>
      </div>
    </div>
  );
}

export default TopBar;
